// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ob-0";
export var buttonContainer = "_ob-3";
export var cancelButton = "_ob-4";
export var headerSection = "_ob-6";
export var headerTitle = "_ob-9";
export var messageSideLeft = "_ob-1";
export var messageSideRight = "_ob-2";
export var orderNumberContainer = "_ob-7";
export var orderNumberLabel = "_ob-8";
export var submitButton = "_ob-5";